import React from "react";
import { Avatar, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import { NavLink } from "react-router-dom";

const useCastStyles = makeStyles((theme) => ({
  castRoot: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  link: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  castAvatar: {
    height: 120,
    width: 120,
  },
  castText: {
    textAlign: "center",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: 150,
  },
  personName: {
    fontSize: 14,
    color: "#eeeeee",
  },
  character: {
    lineHeight: 1,
    fontSize: 12,
    color: theme.palette.grey[400],
  },
}));

interface CastCardProps {
  person_slug: string;
  name: string;
  character: string;
  image: string | null;
  // prevLocation?: PreviousLocation;
}
export const CastCard: React.FC<CastCardProps> = ({ name, character, image, person_slug }) => {
  const classes = useCastStyles();
  // const navLinkState = Object.assign({}, prevLocation ? { prevLocation } : {});
  return (
    <div className={classes.castRoot}>
      <NavLink className={classes.link} to={{ pathname: `/person/${person_slug}` /* state: navLinkState */ }}>
        <Avatar className={classes.castAvatar} alt={name} src={image || undefined} title={name}>
          {image ? null : name.charAt(0)}
        </Avatar>
        <Typography component="div" className={clsx([classes.castText, classes.personName])} title={name}>
          {name}
        </Typography>
      </NavLink>
      <Typography component="span" className={clsx([classes.castText, classes.character])} title={character}>
        {character}
      </Typography>
    </div>
  );
};

export default CastCard;
